import { useMutation } from '@provision/graphql-client';
import { CREATE_INITIAL_MEMBERSHIPS_CONFIG_MUTATION } from 'src/graphql/entities/activation-flow-config/activation-flow-config.operations';
import type {
  CreateInitialMembershipsConfigMutationData,
  CreateInitialMembershipsConfigMutationVariables,
} from 'src/graphql/entities/activation-flow-config/activation-flow-config.types';

export const useCreateInitialMembershipsConfig = () => {
  const [createInitialMembershipsConfig, { loading, error }] = useMutation<
    CreateInitialMembershipsConfigMutationData,
    CreateInitialMembershipsConfigMutationVariables
  >(CREATE_INITIAL_MEMBERSHIPS_CONFIG_MUTATION);

  return {
    createInitialMembershipsConfig,
    loading,
    error,
  };
};
